import App from './App'
import { worker } from './mocks/browser'
import 'prove-common/styles/index.css'
import { bootstrapApp } from 'prove-common/bootstrap'
import { BASE_URL } from './constants'

await bootstrapApp({
  appId: 'proveta',
  App,
  baseUrl: BASE_URL,
  persistQueryKeys: ['ansatte', 'ownerIdString'],
  startWorker: () => worker.start(),
  testRoles: ['employee'],
  testUserName: 'Testbruker (employee)'
})
